module.exports = __webpack_public_path__ + "static/workn_phone-4bea12de9bebf2c23b41afd3e41ab2ec.png";